const initialState = {};

export default function UserInfo(state = initialState, action = {}) {
  switch (action.type) {
    default:
      return state;
  }
}
